import React from 'react';
import Artistic from '../../images/home/wall.jpg';
import { motion } from "framer-motion";
import { MdArrowRightAlt } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import Fadeup from '../fadeup/Fadeup';

function DrawBanner() {
    const navigate = useNavigate();
    return (
        <section className="sec_pd bg-light bg_wall">
            <div className="rounded p-5">
                    <div className="row g-4 align-items-end">
                    <div className="row g-4 align-items-end justify-content-end">
                        <div className="col-12 col-md-12 d-flex flex-column align-items-md-end text-md-end text-center text-container-mobile">
                            <Fadeup delay={0.3}>
                            <h3 className="text-black cus_font-art pb-2">The Artistic Gallery</h3>
                            <h3 className="text-black cus_font-art pb-2">Behind the Scenes Magic</h3>
                            <h3 className="text-black cus_font-art pb-2">Canvas of Imagination</h3>
                            <Link
                                to="/auction"
                                className="btn signup-btn text-white position-relative overflow-hidden border-0"
                            >
                                <div
                                className="swift-btn_animation d-flex justify-content-center align-items-center"
                                style={{
                                    background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))",
                                }}
                                >
                                <p className="m-0 text-black fw-bold button_name">Explore</p>
                                </div>
                            </Link>
                            </Fadeup>
                        </div>
                        </div>

            
                       
                    </div>
                </div>
        </section>
    );
}

export default DrawBanner;
